module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/013-italy-87998fab63421bd0afc283c2f20311ee.svg";